import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import Verso from './Verso';

const VersoContainer = (props) => {
  const { t } = useTranslation();
  const [mediaDuration, setMediaDuration] = useState(' ');
  return (
    <Verso
      mediaDuration={mediaDuration}
      setMediaDuration={setMediaDuration}
      t={t}
      {...props}
    />
  );
};

VersoContainer.defaultAnswer = () => '';

VersoContainer.defaultSolution = () => ({
  user: null,
});

export default VersoContainer;
